<template>
  <div v-if="showDetail">
    <ScrollView>
      <HeaderDetail
        :breadcrumb-nav="[
          {
            label: '储值卡业务办理'
          },
          {
            label: '详情'
          }
        ]"
        :title="`卡号: ${detailConfig.cardNo}`"
      >
        <div slot="right">
          <a-button @click="handleBack">返回</a-button>
        </div>
        <PanelBox title="基础信息">
          <FieldInfoList
            :label-width="80"
            :column="2"
            :data="detailConfig.detailModel"
            :fields="detailConfig.fields"
          ></FieldInfoList>
        </PanelBox>
        <PanelBox title="授权车辆">
          <a-table :pagination="false" :columns="plateTable.columns" :dataSource="plateTable.dataSource"> </a-table>
        </PanelBox>
        <PanelBox title="余额明细">
          <a-table :pagination="false" :columns="balanceTable.columns" :dataSource="balanceTable.dataSource"> </a-table>
        </PanelBox>
      </HeaderDetail>
    </ScrollView>
  </div>
</template>

<script>
import { post } from '@/utils/httpWrap';
import { hiddenTel, formatPermanent } from '@/utils/util';

export default {
  data: () => {
    return {
      showDetail: false,
      detailConfig: {},
      plateTable: {},
      balanceTable: {}
    };
  },
  async created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        const data = await post('bangdao/saasapi/v1/storedCard/detail', JSON.parse(this.$route.query.detail));

        this.showDetail = true;
        this.handleData(data.data);
      } catch (error) {
        console.error('详情页请求失败！');
      }
    },
    // 处理后台返回数据
    handleData(data) {
      this.detailConfig = {
        cardNo: data.cardNO,
        fields: [
          {
            label: '开办时间',
            prop: 'createTime'
          },
          {
            label: '车场名称',
            prop: 'parkName'
          },
          {
            label: '储值类型',
            prop: 'storedType'
          },
          {
            label: '姓名',
            prop: 'ownerName'
          },
          {
            label: '联系电话',
            prop: 'phoneNumber'
          },
          {
            label: '授权期限',
            prop: 'endDate'
          }
        ],
        detailModel: {
          ...data,
          phoneNumber: hiddenTel(data.phoneNumber),
          endDate: formatPermanent(data.endDate)
        }
      };

      const plateData = {
        columns: [
          {
            title: '序号',
            width: 55,
            customRender: (text, record, index) => {
              return index + 1;
            }
          },
          {
            title: '车牌号',
            dataIndex: 'plate',
            width: 120
          },
          {
            title: '车型',
            dataIndex: 'carType',
            width: 120
          },
          {
            title: '车辆品牌',
            dataIndex: 'brand',
            width: 110
          },
          {
            title: '车身颜色',
            dataIndex: 'color',
            width: 110
          },
          {
            title: '操作时间',
            dataIndex: 'createTime',
            width: 225
          },
          {
            title: '操作人',
            dataIndex: 'createBy',
            width: 110
          }
        ],
        dataSource: [...data.storedCardPlateList]
      };

      this.plateTable = plateData;

      //余额明细table数据
      const balanceData = {
        columns: [
          {
            title: '序号',
            width: 55,
            customRender: (text, record, index) => {
              return index + 1;
            }
          },
          {
            title: '业务类型',
            dataIndex: 'tradeType',
            width: 120
          },
          {
            title: '交易金额',
            dataIndex: 'totalAmount',
            width: 120
          },
          {
            title: '平台流水号',
            dataIndex: 'tradeNo',
            width: 300
          },
          {
            title: '交易时间',
            dataIndex: 'createTime',
            width: 225
          },
          {
            title: '当前余额',
            dataIndex: 'balance',
            width: 120
          }
        ],
        dataSource: [...data.storedCardBalanceDetailList]
      };
      this.balanceTable = balanceData;
    },
    handleBack() {
      this.$router.back();
    }
  }
};
</script>

<style></style>
